'use client';
import { useParams, usePathname, useRouter } from 'next/navigation';
import React from 'react';

import { CONTACT_US_ROUTE } from '@/app/[lang]/Router/routes';
import Image from '@/components/core/Image';
import { useDeviceSize } from '@/hooks/useDeviceSize';
import { useTranslation } from '@/hooks/useTranslations';
import partnerglobal from '@/public/assets/Images/partner-global.png';
import ricoToucan from '@/public/assets/Images/rico-toucan.png';

const BecomePartner = ({ show = false, buttonId }: { show?: boolean; buttonId: string }) => {
  const { isMobile } = useDeviceSize();
  const { t } = useTranslation();
  const pathname = usePathname();
  const params = useParams();
  const router = useRouter();

  const showBecomePartnerRoutes = [
    { mobile: true, desktop: true, route: `/${params.lang}/rico-series` },
    { mobile: true, desktop: true, route: '/rico-series' },
    { mobile: true, desktop: false, route: `/${params.lang}/about-us` },
    { mobile: true, desktop: false, route: '/about-us' },
    {
      mobile: true,
      desktop: true,
      route: `/${params.lang}/games/${params.category}/${params.game}`,
    },
    {
      mobile: true,
      desktop: true,
      route: `/games/${params.category}/${params.game}`,
    },
  ];

  const shouldShow = showBecomePartnerRoutes.some(
    (route) =>
      route.route === pathname && ((isMobile && route.mobile) || (!isMobile && route.desktop))
  );

  if (!show && !shouldShow) {
    return null;
  }

  return (
    <div className="becomePartnerHolder slot-mach">
      <div className="becomePartnerLeftBlock">
        <p className="becomePartnerLeftTitle">{t('Avi-Becomeapartner-Title')}</p>
        <p className="becomePartnerLeftInfo">{t('Avi-Becomeapartner-Desc')}</p>
        <div className="becomePartnerLeftBtn">
          <button
            id={buttonId}
            onClick={() => router.push(CONTACT_US_ROUTE.getPath(params.lang as string))}
            className="button btnTypeBig btnTypeWhiteGreen"
          >
            <p>{t('Avi-Becomeapartner-Button')}</p>
            <i className="bc-i-go-to btnIcon btnIconSmall" />
          </button>
        </div>
      </div>
      <div className="becomePartnerImgBlock">
        <Image
          src={
            pathname === `/${params.lang}/rico-series` || pathname === '/rico-series'
              ? ricoToucan
              : partnerglobal
          }
          alt=""
        />
      </div>
    </div>
  );
};

export default BecomePartner;
